import { TrackingTypeState } from 'components/search/bex/interfaces';
import { TrackingType } from 'components/search/bex/enums';

const initialTrackingTypeState: TrackingTypeState = {
  // trackingType: TrackingType.NONE,
  trackingType: TrackingType.CJ,
};

export { initialTrackingTypeState };
